{
  "common": {
    "on": "Activé",
    "off": "Désactivé",
    "yes": "Oui",
    "no": "Non",
    "cancel": "Annuler",
    "networkError": "Erreur réseau — vérifiez la connexion"
  },
  "platform": {
    "shopify": "Shopify",
    "etsy": "Etsy",
    "woocommerce": "WooCommerce",
    "tiktok": "TikTok",
    "amazon": "Amazon",
    "printway": "Printway",
    "manual": "Manuel",
    "unknown": "Inconnu"
  },
  "statusLabels": {
    "Active": "Actif",
    "Inactive": "Inactif",
    "Frozen": "Gelé",
    "Disconnected": "Déconnecté"
  },
  "syncHealthLabels": {
    "healthy": "Bon",
    "warning": "Avertissement",
    "critical": "Critique",
    "unknown": "Inconnu"
  },
  "syncJobStatusLabels": {
    "succeeded": "Réussi",
    "failed": "Échoué",
    "running": "En cours",
    "queued": "En file",
    "dlq": "DLQ"
  },
  "autoPush": {
    "immediate": "Immédiat",
    "30m": "30 min",
    "1h": "1 heure",
    "4h": "4 heures",
    "manual": "Manuel"
  },
  "list": {
    "title": "Boutiques",
    "subtitle": "Gérez les connexions des boutiques, surveillez le Sync Health et traitez la DLQ. Une boutique gelée retient les commandes entrantes et met la synchronisation en pause jusqu'à sa réactivation.",
    "openQueueMonitor": "Ouvrir Queue Monitor →",
    "openBullBoardTitle": "Ouvrir Bull Board",
    "empty": "Aucune boutique ne correspond aux filtres.",
    "tabsAria": "Onglets de filtre des boutiques",
    "tabs": {
      "all": "Toutes",
      "active": "Actif",
      "inactive": "Inactif",
      "frozen": "Gelé",
      "disconnected": "Déconnecté"
    },
    "columns": {
      "name": "Nom",
      "platform": "Plateforme",
      "merchant": "Marchand",
      "status": "Statut",
      "syncHealth": "État",
      "lastSync": "Dernière sync",
      "lastSyncStatus": "Statut sync",
      "syncErrors24h": "Erreurs 24h",
      "products": "Produits",
      "orders": "Commandes",
      "webhooks": "Webhooks",
      "autoTracking": "Suivi auto",
      "autoPush": "Envoi auto",
      "tokenExpiry": "Expiration token",
      "created": "Créé"
    },
    "filters": {
      "search": {
        "label": "Recherche",
        "placeholder": "Domaine de la boutique, marchand…"
      },
      "platform": {
        "label": "Plateforme"
      },
      "syncHealth": {
        "label": "État de sync"
      }
    },
    "actions": {
      "openStoreAria": "Ouvrir la boutique {{name}}",
      "openStoreTitle": "Ouvrir le détail de la boutique"
    },
    "legend": {
      "title": "Légende des lignes :",
      "aria": "Légende des couleurs de ligne",
      "criticalHealth": "État critique",
      "frozen": "Gelé",
      "disconnected": "Déconnecté"
    }
  },
  "kpi": {
    "totalStores": {
      "label": "Total des boutiques",
      "sub": "tous marchands confondus"
    },
    "active": {
      "label": "Actif",
      "sub": "connectées & en sync"
    },
    "attention": {
      "label": "Nécessite attention",
      "sub": "gelées ou déconnectées"
    }
  },
  "detail": {
    "missingId": "Identifiant de boutique manquant dans l'URL.",
    "loading": "Chargement du détail de la boutique…",
    "back": "Retour aux Boutiques",
    "statusTitle": "Statut de connexion (OAuth + état de gel)",
    "platformLabel": "Plateforme :",
    "merchantLabel": "Marchand :",
    "tabsAria": "Onglets du détail de la boutique",
    "tabs": {
      "info": "Infos",
      "config": "Config sync",
      "orders": "Commandes",
      "products": "Produits",
      "history": "Historique sync",
      "health": "État sync",
      "webhook": "Webhook"
    },
    "actions": {
      "forceSync": "Forcer la sync",
      "unfreeze": "Dégeler",
      "unfreezing": "Dégel en cours…",
      "freeze": "Geler",
      "disconnect": "Déconnecter"
    },
    "info": {
      "storeInfoTitle": "Infos boutique",
      "name": "Nom",
      "platform": "Plateforme",
      "shopDomain": "Domaine de la boutique",
      "platformStoreId": "ID boutique sur la plateforme",
      "status": "Statut",
      "connectedAt": "Connectée le",
      "frozenReason": "Raison du gel",
      "merchantInvoicesTitle": "Marchand + Factures (08.2)",
      "merchant": "Marchand",
      "merchantId": "ID marchand",
      "tokenExpiry": "Expiration du token",
      "invoiceCrossLink": "Le lien des factures vers la Phase 8.2 arrivera dans ADMIN-22.",
      "adminActionsLogTitle": "Journal des actions admin",
      "adminActionsLogBody": "Le journal d'audit déconnexion / gel / dégel / sync forcée arrivera via task-45 (le BE d'impersonation écrit les lignes d'audit).",
      "lastErrorFromSync": "Dernière erreur de sync :"
    },
    "config": {
      "title": "Config sync",
      "productSync": "Sync produits",
      "orderSync": "Sync commandes",
      "mappingAi": "Mapping IA",
      "autoPushInventory": "Envoi auto du stock",
      "autoPushOrderConfig": "Config d'envoi auto des commandes"
    },
    "history": {
      "dlqBanner_one": "Les erreurs de plus de {{count}} jour sont automatiquement purgées.",
      "dlqBanner_other": "Les erreurs de plus de {{count}} jours sont automatiquement purgées.",
      "empty": "Aucune sync pour le moment.",
      "columns": {
        "queue": "File",
        "status": "Statut",
        "started": "Démarrée",
        "finished": "Terminée",
        "error": "Erreur"
      }
    },
    "webhook": {
      "title": "Enregistrement Webhook",
      "secretPresent": "Secret présent",
      "endpointToken": "Token d'endpoint",
      "scopes": "Scopes",
      "revealSecret": "Afficher le secret",
      "remaskingIn": "Re-masquage dans {{seconds}}s…",
      "revealPrompt": "Confirmez votre mot de passe admin pour voir le secret du webhook. Le secret sera re-masqué après 30s.",
      "autoRemaskNote": "le secret est automatiquement re-masqué après 30 secondes."
    },
    "toast": {
      "unfrozenTitle": "Boutique dégelée",
      "unfrozenDesc": "Statut de connexion rétabli sur Actif.",
      "unfreezeFailTitle": "Échec du dégel",
      "frozenTitle": "Boutique gelée",
      "frozenDesc": "{{name}} est maintenant Gelée.",
      "syncQueuedTitle": "Sync mise en file",
      "syncQueuedDesc": "Le job {{jobId}} a été planifié.",
      "disconnectedTitle": "Boutique déconnectée",
      "disconnectedDesc": "{{name}} a été déconnectée."
    }
  },
  "syncHealth": {
    "title": "État de sync",
    "subtitle": "Taux d'erreur 24h, sparkline 7 jours et historique des erreurs les plus récentes.",
    "errorRate24h": "Taux d'erreur 24h :",
    "dlqBanner_one": "Les erreurs de plus de {{count}} jour sont automatiquement purgées (rétention TTL DLQ gérée par la Phase 5).",
    "dlqBanner_other": "Les erreurs de plus de {{count}} jours sont automatiquement purgées (rétention TTL DLQ gérée par la Phase 5).",
    "sparklineTitle": "Sparkline (7 jours)",
    "sparklineAria": "Sparkline du taux d'erreur sur 7 jours",
    "webhookTitle": "Livraison webhook (24h)",
    "webhookAria": "Statistiques de livraison webhook (24h)",
    "received": "Reçus :",
    "processed": "Traités :",
    "failed": "Échoués :",
    "recentErrorsTitle": "Erreurs récentes (10 lignes)",
    "recentErrorsAria": "10 dernières erreurs de sync",
    "noRecentErrors": "Aucune erreur récente.",
    "loading": "Chargement de l'état de sync…",
    "columns": {
      "queue": "File",
      "status": "Statut",
      "class": "Classe",
      "started": "Démarrée",
      "retry": "Réessais",
      "error": "Erreur"
    }
  },
  "orders": {
    "title": "Commandes de la boutique",
    "showingLatest_one": "Affichage de la {{count}} dernière commande par date de création.",
    "showingLatest_other": "Affichage des {{count}} dernières commandes par date de création.",
    "totalAvailable": "Total des commandes disponibles :",
    "viewAll": "Voir tout dans Admin Orders →",
    "loading": "Chargement des commandes…",
    "empty": "Aucune commande de cette boutique pour le moment.",
    "columns": {
      "orderNumber": "N° commande",
      "status": "Statut",
      "payment": "Paiement",
      "items": "Articles",
      "total": "Total",
      "received": "Reçue"
    }
  },
  "products": {
    "title": "Produits sur la boutique",
    "subtitle": "Les produits Printway sont liés à la boutique via le mapping SKU. Voir les détails dans le Mapping Center.",
    "openMapping": "Ouvrir Mapping Center →",
    "pendingTitle": "Mapping en attente (ouvert)",
    "pendingSubtitle": "SKU inconnus de la boutique pas encore mappés au catalogue Printway. Total :",
    "loading": "Chargement du mapping…",
    "empty": "Aucun mapping en attente — tous les SKU ont été résolus.",
    "columns": {
      "externalSku": "SKU externe",
      "title": "Titre",
      "status": "Statut",
      "created": "Créé"
    },
    "notePrefix": "La liste « Mapped SKUs » (résolus) n'a pas encore d'endpoint dédié — elle sera ajoutée lorsque le BE exposera",
    "noteSuffix": "(amendement Phase 8.1 en attente)."
  },
  "modals": {
    "disconnect": {
      "title": "Déconnecter la boutique",
      "descPrefix": "Déconnecter la boutique",
      "descSuffix": ". Le refresh token OAuth sera supprimé ; le marchand devra se reconnecter de zéro. Les webhooks cesseront de recevoir de nouveaux événements. C'est une action destructive.",
      "confirmTypePrefix": "Tapez",
      "confirmTypeSuffix": "pour confirmer",
      "noteLabel": "Note (facultatif)",
      "notePlaceholder": "Raison de la déconnexion (journal d'audit)",
      "submit": "Déconnecter la boutique",
      "submitting": "Déconnexion…"
    },
    "forceSync": {
      "title": "Forcer la sync",
      "descWithName": "Forcer une re-synchronisation de « {{name}} ». Le système ajoutera un sync_job à la file BullMQ et le worker de la Phase 5 le traitera dès qu'il sera disponible.",
      "descNoName": "Forcer une re-synchronisation. Le système ajoutera un sync_job à la file BullMQ et le worker de la Phase 5 le traitera dès qu'il sera disponible.",
      "queueLabel": "Type de file",
      "queues": {
        "polling": "Polling — re-récupérer commandes + produits",
        "orderImport": "Order Import — re-tirer les commandes récentes",
        "productSync": "Product Sync — pousser les mises à jour du catalogue"
      },
      "submit": "Forcer la sync",
      "submitting": "Planification…"
    },
    "freeze": {
      "title": "Geler la boutique",
      "descWithName": "Geler la boutique « {{name}} ». La sync s'arrêtera et les prochaines commandes seront retenues. Le marchand sera notifié. Vous pourrez la dégeler plus tard.",
      "descNoName": "Geler la boutique. La sync s'arrêtera et les prochaines commandes seront retenues. Le marchand sera notifié. Vous pourrez la dégeler plus tard.",
      "reasonLabel": "Raison",
      "reasonPlaceholder": "Ex. : violation de la politique / fraude suspectée / pause demandée par le marchand",
      "reasonCounter": "{{len}}/{{max}} caractères — minimum {{min}}.",
      "noteLabel": "Note (facultatif)",
      "notePlaceholder": "Note interne — non visible par le marchand",
      "submit": "Geler la boutique",
      "submitting": "Gel en cours…"
    }
  }
}
